import { useState } from 'react'

import { Input } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { Image } from '@skytech/ui/Image'
import { useDispatch, useSelector } from 'react-redux'

import { API_PATH_ECOM_ORDER } from '@/api/apiRoutes'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import Error from '@/components/util/Error'
import {
  getAddress,
  getCity,
  getError,
  getIsAddressValid,
  getOrderId,
  getSelectedProductIds,
  getSelectedProducts,
  getZip,
  setAddress,
  setCity,
  setError,
  setOrderId,
  setZip,
} from '@/ducks/hardwareReducer'
import { post } from '@/util/auth'

import { Translation } from '../i18n/Translation'

import './confirmation.scss'

const Confirmation = () => {
  const dispatch = useDispatch()

  const selectedProducts = useSelector(getSelectedProducts)
  const selectedProductIds = useSelector(getSelectedProductIds)

  const [isLoading, setIsLoading] = useState(false)

  const address = useSelector(getAddress)
  const zip = useSelector(getZip)
  const city = useSelector(getCity)
  const isAddressValid = useSelector(getIsAddressValid)

  const orderId = useSelector(getOrderId)
  const error = useSelector(getError)

  const onSubmit = async () => {
    if (!isLoading) {
      setIsLoading(true)
      try {
        const { orderId } = await post(API_PATH_ECOM_ORDER, {
          selectedProductIds,
          address,
          zip,
          city,
        })
        dispatch(setOrderId(orderId))
      } catch (error) {
        dispatch(setError('Unknown error...'))
      } finally {
        setIsLoading(false)
      }
    }
  }

  if (orderId) {
    return (
      <div className="confirmation">
        <h3>Ordre mottatt</h3>
        <p>
          Din bestilling er registrert. Du vil umiddelbart motta en SMS med informasjon om din
          bestilling, og ordren blir sendt til Dustin. Du mottar deretter en ordrebekreftelse per
          e-post fra Dustin. Mottar du ikke denne ordrebekreftelsen innen 24 timer, så ta kontakt
          med Dustins kundeservice.
        </p>

        <h3>Spørsmål om ordre</h3>
        <p>
          Bestillinger i Skytech Control-portalen går direkte til leverandør. ITS har derfor ikke
          mulighet til å besvare spørsmål om levering, produkter, endringer på ordre etc. Har du
          spørsmål vedrørende leveringstid eller produkter som du har bestilt, kontakt Dustins
          kundeservice, se kontaktinfo under. Anbefaler å benytte e-post, da det kan vøre noe
          ventetid på tlf.
          <br />
          <br />
          Viktig: Ha ditt ordrenummer klart før du ringer og legg det alltid med i en e-post.
          Ordrenummer finner du på ordrebekreftelsen du mottar.
        </p>

        <h3>Levering</h3>
        <p>
          Skjermer, docking, ekstra power og Apple AirPods leveres til nærmeste post i butikk. Du
          får melding/epost når det kan hentes.
          <br />
          <br />
          Skrivebord, stol, lampe, induksjonslader, tastatur/mus og WEB Cam leveres til din dør av
          Posten/Bring. Er du ikke hjemme, så leveres utstyret til nærmeste post i butikk, du blir
          informert med melding/epost hvis så skjer.
        </p>

        <h3>Levering</h3>
        <p>
          E-post: storkunde@dustin.no (foretrukket kontaktpunkt)
          <br />
          Tlf: 21 04 40 70 (kan være noe ventetid på tlf.)
          <br />
          www.dustin.no
          <br />
        </p>
      </div>
    )
  }

  return (
    <div className="confirmation">
      <h3>Ordrebekreftelse</h3>
      <table>
        <tbody>
          {/* @ts-ignore */}
          {selectedProducts.map(product => (
            <Product key={product.id} {...product} />
          ))}
        </tbody>
      </table>

      <div className="address">
        <div className="street">
          <Input
            id="delivery-address"
            label={<Translation id="leveringsadresse" />}
            value={address}
            onChange={e => dispatch(setAddress(e.target.value))}
          />
        </div>

        <div className="zip">
          <Input
            id="zip"
            label={<Translation id="postnr" />}
            maxLength={10}
            value={zip}
            onChange={e => dispatch(setZip(e.target.value))}
          />
        </div>

        <div className="city">
          {/* todo: add city validation */}
          <Input
            capitalizeLabel
            id="zip-code"
            label={<Translation id="poststed" />}
            value={city}
            onChange={e => dispatch(setCity(e.target.value))}
          />
        </div>
      </div>

      <Error active={!!error}>{error}</Error>

      <Button variant="primary" onClick={onSubmit} disabled={isLoading || !isAddressValid}>
        Bekreft ordre
      </Button>
    </div>
  )
}

const Product = ({ img_url, name, buying_price }: any) => (
  <tr>
    <td className="img">
      <Image src={img_url} alt="product" />
    </td>

    <td className="name">{name}</td>

    <td className="amount number">
      <FormattedNumberWithCurrency amount={buying_price} />
    </td>
  </tr>
)

export default Confirmation
